import { IconComponent } from './types';

const WarningIcon: IconComponent = ({ className }) => {
  return (
    <svg
      className={className}
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 320.83 320.83"
      fill="currentColor"
    >
      <path
        d="M180.494,39.687l-1.333-1.327c-5.009-5.015-11.667-7.772-18.754-7.772
			c-7.082,0-13.739,2.758-18.748,7.767l-1.333,1.333L5.551,256.847c-5.466,6.413-7.016,14.196-4.112,21.207
			c3.16,7.631,10.704,12.189,20.173,12.189h277.604c9.475,0,17.013-4.558,20.173-12.189c2.904-7.011,1.354-14.8-4.112-21.207
			L180.494,39.687z M43.484,257.614L160.413,69.221l116.934,188.393H43.484z"
      />
      <path
        d="M143.758,122.002v71.388c0,9.197,7.457,16.654,16.654,16.654s16.654-7.457,16.654-16.654v-71.388
			c0-9.197-7.457-16.654-16.654-16.654C151.215,105.347,143.758,112.804,143.758,122.002z"
      />
      <circle cx="160.244" cy="234.906" r="16.486" />
    </svg>
  );
};

export default WarningIcon;
